import './PolicyBenefit.less';
import {
  Row,
  Col,
  Divider,
  // Card,
  // Button,
  // Grid,
  Collapse,
} from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { isLocaleEnglish } from 'utils/languageUtils';
import KnowMoreArrowIcon from 'assets/images/home/chevron-right-red.svg';
import { useLifePolicyValue } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';
import { useEffect } from 'react';

const { Panel } = Collapse;
// import ChevronRight from 'assets/images/home/chevron-right.svg';
import ChevronUp from 'assets/images/home/chevron-up.svg';
import ArrowClose from 'assets/images/home/arrow-close.svg';
import { BenefitDaum } from 'all-in-one-shared-api/dist/apis/policy/useLifePolicyDetail';
import { formatBenefit } from 'utils/liPolicies';
import { useNavigate } from 'react-router-dom';
interface DividerLineProps {
  padB?: string;
  marT?: string;
}
interface PolicyBenefitProps {
  benefit?: BenefitDaum[];
  policyNo?: string;
  companyCode?: string;
  planCode?: string;
}
interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
const StyledBlock = styled.div`
  width: 100%;
  background: #fff;
  margin-bottom: 1rem;
`;
const Androw = styled(Row)<PdRowProps>`
  max-width: 672px;
  margin: 0 auto;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  // margin: 0 16px;
`;
const AntDivider = styled(Divider)`
  border-color: #cccccc;
`;
const DividerLine = ({ padB, marT }: DividerLineProps) => {
  return (
    <Androw justify="start" padB={padB}>
      <AndCol style={{ width: '100%' }}>
        <AntDivider style={{ margin: '8px 0', marginTop: marT ? marT : '8px' }}></AntDivider>
      </AndCol>
    </Androw>
  );
};
const KnowMoreLinkImage = styled.img`
  margin-left: 12px;
  width: 14px;
  height: 8px;
`;
const PolicyBenefit = ({ benefit, policyNo, companyCode, planCode }: PolicyBenefitProps): JSX.Element => {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const formatedBenefit = formatBenefit(benefit, isEnglish);
  const navigate = useNavigate();
  const { token } = useKeycloakReady();

  const { shouldFetch, data } = useLifePolicyValue(
    'useLifePolicyValue',
    token ?? '',
    policyNo ?? '',
    companyCode ?? '',
  );
  const viewValues = () => {
    navigate('/PoliciesValues', {
      state: {
        policyNo,
        companyCode,
        planCode,
      },
    });
  };
  useEffect(() => {
    if (policyNo && companyCode) shouldFetch(true);
  }, [shouldFetch, policyNo, companyCode]);
  const ExpandContent = () => {
    return (
      <div>
        {formatedBenefit
          ?.filter((item) => item.basicPlanFlag == 'Y')
          ?.map((benefit, index) => {
            return (
              <div key={index}>
                <Androw justify="start">
                  <AndCol>
                    <div className="tagging">
                      <span className="font-size17 font-setting500 grey-font">{t('life.policies.BasicPlan')}</span>
                      <span className="font-size17 ">{benefit.basicPlanDescTitle}</span>
                    </div>
                  </AndCol>
                </Androw>
                <DividerLine></DividerLine>
                {benefit.benefitProductDesc !== 'N/A' && (
                  <>
                    <Androw justify="start">
                      <AndCol>
                        <div className="tagging">
                          <span className="font-size17 font-setting500 grey-font">
                            {t('life.policies.BasicPlan') + '-' + benefit.benefitProductDescTitle}
                          </span>
                          <span className="font-size17 ">
                            {benefit.benefitCurrDescTitle + (benefit?.amount ? benefit?.amount : '')}
                          </span>
                        </div>
                      </AndCol>
                    </Androw>
                    <DividerLine></DividerLine>
                  </>
                )}

                {formatedBenefit.find((i) => i.basicPlanFlag == 'N') && <DividerLine marT="0"></DividerLine>}
              </div>
            );
          })}
        {formatedBenefit
          ?.filter((item) => item.basicPlanFlag == 'N')
          ?.map((benefit, index) => {
            return (
              <div key={index + '-extra'}>
                <Androw justify="start">
                  <AndCol>
                    <div className="tagging">
                      <span className="font-size17 font-setting500 grey-font">
                        {t('life.policies.Supplementarybenefit')}
                      </span>
                      <span className="font-size17 ">{benefit.basicPlanDescTitle}</span>
                    </div>
                  </AndCol>
                </Androw>
                {benefit?.amount && benefit?.amount != '-' && (
                  <>
                    <DividerLine></DividerLine>
                    <Androw justify="start">
                      <AndCol>
                        <div className="tagging">
                          <span className="font-size17 font-setting500 grey-font">
                            {t('life.policies.Supplementarybenefit') + '-' + benefit.benefitProductDescTitle}
                          </span>
                          <span className="font-size17 ">
                            {benefit.benefitCurrDescTitle + (benefit.amount ? benefit.amount : '')}
                          </span>
                        </div>
                      </AndCol>
                    </Androw>
                  </>
                )}
                <DividerLine></DividerLine>
                <DividerLine marT="0"></DividerLine>
              </div>
            );
          })}
        {formatedBenefit
          ?.filter((item) => item.basicPlanFlag == 'Y')
          ?.map((benefit, index) => {
            return (
              <div key={index}>
                <Androw justify="start">
                  <AndCol>
                    <div className="tagging">
                      <span className="font-size17 font-setting500 grey-font">{t('life.policies.PaymentMode')}</span>
                      <span className="font-size17 ">{benefit.paymentModeDescTitle}</span>
                    </div>
                  </AndCol>
                </Androw>
                <DividerLine></DividerLine>
                <Androw justify="start">
                  <AndCol>
                    <div className="tagging">
                      <span className="font-size17 font-setting500 grey-font">
                        {benefit?.amount && benefit?.amount != '-' && benefit?.paymentMode == '00'
                          ? t('life.policies.SinglePreminum')
                          : t('life.policies.ModalPreminum')}
                      </span>
                      <span className="font-size17 ">
                        {benefit.modalPremium == '-'
                          ? '-'
                          : benefit.premiumCurrDescTitle + (benefit?.modalPremium ? benefit?.modalPremium : '')}
                      </span>
                    </div>
                  </AndCol>
                </Androw>
                <DividerLine></DividerLine>
                {!(benefit?.amount && benefit?.amount != '-' && benefit?.paymentMode == '00') && (
                  <>
                    <Androw justify="start">
                      <AndCol>
                        <div className="tagging">
                          <span className="font-size17 font-setting500 grey-font">
                            {t('life.policies.PremiumCessationDate')}
                          </span>
                          <span className="font-size17 ">{benefit.premiumCDate}</span>
                        </div>
                      </AndCol>
                    </Androw>
                    <DividerLine></DividerLine>
                  </>
                )}
              </div>
            );
          })}
      </div>
    );
  };
  return (
    <div className="benefit-wrapper">
      <StyledBlock>
        <Androw justify="start">
          <AndCol style={{ width: '100%' }}>
            <Collapse
              className="font-size26 grey-font"
              style={{ backgroundColor: '#fff' }}
              collapsible="header"
              bordered={false}
              expandIconPosition="end"
              expandIcon={({ isActive }) => {
                return isActive ? <img src={ChevronUp} /> : <img src={ArrowClose} />;
              }}
            >
              <Panel header={t('life.policies.PolicyBenefitSummary')} key="1" className="grey-font">
                <ExpandContent></ExpandContent>
                {data?.policyValues && data?.policyValues.length > 0 && (
                  <Androw
                    justify="center"
                    style={{
                      height: '49px',
                    }}
                  >
                    <AndCol onClick={viewValues} style={{ cursor: 'pointer' }}>
                      <div className="view-info">
                        <span className="font-setting500 font-size17  red-font">
                          {t('life.policies.ViewPolicyValues')}
                        </span>
                        <KnowMoreLinkImage src={KnowMoreArrowIcon} alt="know-more-arrow" />
                      </div>
                    </AndCol>
                  </Androw>
                )}
              </Panel>
            </Collapse>
          </AndCol>
          {/* <AntDivider style={{ margin: '8px 0' }}></AntDivider> */}
        </Androw>
      </StyledBlock>
    </div>
  );
};

export default PolicyBenefit;
